export const domain = 'User';

// action types
export const IS_LOGGING_IN = `${domain}/IS_LOGGING_IN`;
export const IS_REGISTERING = `${domain}/IS_REGISTERING`;
export const LAST_ACTIVITY = `${domain}/LAST_ACTIVITY`;
export const LOGIN_ERROR = `${domain}/LOGIN_ERROR`;
export const LOGIN = `${domain}/LOGIN`;
export const LOGOUT = `${domain}/LOGOUT`;
export const REGISTER_ERROR = `${domain}/REGISTER_ERROR`;
